export default __webpack_public_path__ + "static/media/lynn-artworkinfo4.0a08d67b.png";